<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button> -->
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="12">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl. Allocation</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl" type="month"
              :state="!$v.tblData.tgl.$error"></b-form-input>
            <b-input-group-append>
              <label style="min-width: 75px" class="pt-2 ml-2 text-right">Project</label>
            </b-input-group-append>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="sourceproject"
            :state="!$v.tblData.pjxkey.$error"
            ></b-form-select>
            <b-input-group-append>
              <b-button variant="warning" @click="setUp()" class="ml-3">
                <i class="fa fa-play"></i> Get Data
              </b-button>
              <b-button variant="success" @click="saveSchedule()" class="ml-3">
                <i class="fa fa-save"></i> Save Schedule
              </b-button>
              <!-- <b-button variant="primary ml-2" @click="exportxlsCR()">
                <i class="fa fa-file-excel-o"></i>Export
              </b-button> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Filter</label>
            </b-input-group-prepend>
            <b-form-input id="filter-input" v-model="filter" type="search"
                placeholder="Type to Search"></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
          </b-input-group>
        </b-col>

        <b-col lg="6" class="my-1">
          <b-form-group label="Filter On"
            description="Leave all unchecked to filter on all data" label-cols-md="3" label-align-md="right"
            label-size="md" class="mb-0" v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group v-model="filterOn" :aria-describedby="ariaDescribedby" class="mt-1">
              <b-form-checkbox value="CIF">CIF</b-form-checkbox>
              <b-form-checkbox value="no_kontrak">No Kontrak</b-form-checkbox>
              <b-form-checkbox value="status_allocation">Status</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-card no-body class="mb-0">
        <b-table class="mb-0" ref="table" outlined responsive striped hover style="font-size: smaller"
          :items="tblData.items" :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy" :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" :filter="filterInput"
          :filterIncludedFields="filterOn" @filtered="onFiltered" :busy="isBusy" show-empty>
          <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
          <template v-slot:cell(tanggal)="data">{{
            data.item.tanggal | moment("DD MMM YYYY")
            }}</template>
          <template v-slot:cell(duedate)="data">{{
            data.item.duedate | moment("DD/MM/YY")
            }}</template>
          <template v-slot:cell(cessie_os)="data">{{
            data.item.cessie_os | numFormat("0,0.00")
            }}</template>
          <template v-slot:cell(PREPAID)="data">{{
            data.item.PREPAID | numFormat("0,0.00")
            }}</template>
             <template v-slot:cell(nilaisettl_pokok)="data">{{
            data.item.nilaisettl_pokok | numFormat("0,0.00")
            }}</template>
             <template v-slot:cell(nilaisettl_bunga)="data">{{
            data.item.nilaisettl_bunga | numFormat("0,0.00")
            }}</template>
             <template v-slot:cell(nilaisettl_denda)="data">{{
            data.item.nilaisettl_denda | numFormat("0,0.00")
            }}</template>
             <template v-slot:cell(nilaisettl_other)="data">{{
            data.item.nilaisettl_other | numFormat("0,0.00")
            }}</template>
          <template v-slot:cell(cessie_date)="data">{{
            data.item.cessie_date | moment("DD MMM YY")
            }}</template>
          <template v-slot:cell(tgl_pelunasan)="data">{{
            data.item.tgl_pelunasan | moment("DD MMM YY")
            }}</template>
           <template v-slot:cell(applicable)="data">
            <b-form-checkbox
              v-model="data.item.applicable"
              value="1"
              unchecked-value="0"
            >
            {{ data.item.applicable==1?'Yes':'No' }}
            </b-form-checkbox>
           </template>

         


          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>

        </b-table>
      </b-card>
      <b-row class="m-1">
        <b-col lg="6">
          <b-row v-if="(filterShow == 'Hide')">
            <b-input-group size="sm">
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
              <b-input-group-prepend> <span class="pr-2">
                  <b> {{ filterShow }}</b> Filter </span>
              </b-input-group-prepend>
              <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
            <!-- <b-input-group size="sm" class="ml-4">
              <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
              </b-input-group-prepend>
              <b-form-checkbox-group v-model="filterOn" class="mt-1">
                <b-form-checkbox value="no_agreement">Agreement No.</b-form-checkbox>
                <b-form-checkbox value="CustName">Debitur Name</b-form-checkbox>
                <b-form-checkbox value="KOL_EOM">Collectability</b-form-checkbox>
                <b-form-checkbox value="DefaultStat">Default (WO) status</b-form-checkbox>
              </b-form-checkbox-group>
            </b-input-group>
            <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label> -->
          </b-row>
          <b-row v-else>
            <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
              <b> {{ filterShow }}</b> Filter
            </b-form-checkbox>
          </b-row>
        </b-col>
        <b-col lg="6">
          <div style="display: flex;margin:0;padding:0;">
            <div style="margin:0;padding:5px;width:500px; text-align:right;">
              Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
              to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span
                v-else>{{ tblData.page * tblData.limit }}</span>
              of {{ tblData.total }} , <span class="mr-1">limit per page :</span>
              <select v-model="tblData.limit" style="width:60px;">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>40</option>
                <option>50</option>
                <option>60</option>
                <option>70</option>
                <option>80</option>
                <option>90</option>
              </select>
            </div>
            <div>
              <b-pagination class="ml-1" align="left" :total-rows="tblData.total" :per-page="tblData.limit"
                v-model="tblData.page"></b-pagination>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isBusy" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { validationMixin } from "vuelidate";
import { required, maxValue } from "vuelidate/lib/validators";
import moment from "moment";
import myNumber from "../../components/my-number";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamankredit";
import project from "../../apis/project";
import allocation from "../../apis/allocationprepaid";

toastr.init();
export default {
  components: { myNumber, Loading },
  mixins: [validationMixin],
  validations: {
    tblData: {
      tgl: {required},
      pjxkey: {required}
    }
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      maxdtreport: '',
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        tgl: moment().format('YYYY-MM-DD'),
        admin: 0,
        pjxkey: '',
        pjxname:''
      },
      sourceproject: [],
      filterShow: 'Show',
      filter: null,
      filterInput: null,
      filterOn: ['no_agreement', 'CustName'],
    };
  },
  computed: {
    invalidTblData() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    },
    tblFields() {
      const fields =[
      {
          key: "tanggal",
          label: " Tanggal Alokasi",
          thStyle: "min-width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      'no_kontrak',
      'CIF',
      'cust_name',
      'branch',
      'collectability',
      'cessie_collectability',
      {
          key: "cessie_os",
          label: " Cessie OS",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      'cessie_date',
        {
          key: "PREPAID",
          label: " PREPAID",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      // 'rrd_dt',
      // 'pjxcode',
      'cassie_name',
      'no_memo_pelunasan',
      'tgl_pelunasan',
      'schema_allocation',
      'applicable',
      {
          key: "nilaisettl_pokok",
          label: " Nilaisettl Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilaisettl_bunga",
          label: " Nilaisettl Bunga",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilaisettl_denda",
          label: " Nilaisettl Denda",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilaisettl_other",
          label: " Nilaisettl Other",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      'status_allocation',
      'status_note'
      ]
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    user() {
      return this.$store.state.user;
    },
    timeServer() {
      return moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
    },
    route() {
      return this.$route;
    }
  },
  watch: {
    filterShow: function (newval) {
      setTimeout(() => {
        this.filter = ''
      }, 200);
    },
    filter: function (newval) {
      // this.isBusy=true;
      setTimeout(() => {
        this.filterInput = newval;
      }, 800);
    },
    'tblData.tgl': function (newval) {
      let endOfMonth = moment(`${newval}-01`).endOf('month');
      // this.tblData.tgl = moment(endOfMonth).format('YYYY-MM-DD')
    },
    'tblData.pjxkey': function (newval) {
      const obj = this.sourceproject.find(x=>x.value == newval);
      this.tblData.pjxname = obj.pjxname || '';
    }
  },
  async created() {
    try {
      this.tblData.tgl = moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
      this.maxdtreport = moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
      if (this.route.name == "loan.admin-collection-report") {
        this.tblData.admin = 1;
      }
      const projectDt = await project.listbyuser();
      this.sourceproject = projectDt.map(item=>{
        item.value= item.pjxkey;
        item.text= item.pjxname;
        return item
      })
            
      if(this.sourceproject.length==1) this.tblData.pjxkey = this.sourceproject[0].value

    } catch (error) {
      toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      //this.filterOn= []   
      this.filter = '';
    },

    async setUp() {
      try {
        if (!this.invalidTblData) {
          this.isBusy = true;
          const tblData ={
            tgl:moment(this.tblData.tgl).endOf('month').format('YYYY-MM-DD')
          }
          const list = await allocation.setup(tblData);
          list.map(dt=>{
            dt.applicable = dt.applicable || 1
          })
          this.isBusy = false;
          this.tblData.items = list;
          this.tblData.total = list.length;
        }else{
          this.$bvModal.msgBoxOk('Please fill corectly', {
          title: 'Info',
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'warning',
          headerClass: 'p-2 border-bottom-0 bg-danger',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        }
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async saveSchedule (){
      if (this.invalidTblData) {
        this.$bvModal.msgBoxOk('Please fill corectly', {
          title: 'Info',
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'warning',
          headerClass: 'p-2 border-bottom-0 bg-danger',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
      }else if(this.tblData.items.length==0){
        this.$bvModal.msgBoxOk('Please GET DATA before Create Shcedule', {
          title: 'Info',
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'warning',
          headerClass: 'p-2 border-bottom-0 bg-danger',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
      }else{
        this.$bvModal.msgBoxConfirm('Please confirm that you want to create schedule.', {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async value => {
            if(value==true){
              this.isBusy = true;
              const tblData ={
                tgl:moment(this.tblData.tgl).endOf('month').format('YYYY-MM-DD'),
                items:this.tblData.items
              }
              await allocation.saveSchedule(tblData);
              this.setUp();
              this.isBusy = false;
            }
          })
          .catch(err => {
            // An error occurred
          })
      }
    },
    // async exportxlsCR() {
    //   try {
    //     if (!this.invalidTblData) {
    //       this.isBusy = true;
    //       await pinjaman.exportxlsCR(this.tblData);
    //       this.isBusy = false;
    //     }
    //   } catch (error) {
    //     this.isBusy = false;
    //     if (error.message) {
    //       toastr.error(error.message, "ERROR MESSAGE", 10000);
    //     } else {
    //       toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
    //     }
    //   }
    // },
    close() {
      router.push("home");
    },
  },
};
</script>